import React, { createContext, useState, useContext } from 'react';

// Création du contexte
export const FullscreenContext = createContext();

// Hook personnalisé pour utiliser le contexte
export const useFullscreen = () => useContext(FullscreenContext);

// Provider du contexte
export const FullscreenProvider = ({ children }) => {
  const [isFullscreenActive, setIsFullscreenActive] = useState(false);

  // Fonction pour activer le mode plein écran
  const enableFullscreen = () => {
    setIsFullscreenActive(true);
  };

  // Fonction pour désactiver le mode plein écran
  const disableFullscreen = () => {
    setIsFullscreenActive(false);
  };

  return (
    <FullscreenContext.Provider 
      value={{ 
        isFullscreenActive, 
        enableFullscreen, 
        disableFullscreen 
      }}
    >
      {children}
    </FullscreenContext.Provider>
  );
};
